import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import 'datatables.net';

@Component({
  selector: 'app-assessments',
  templateUrl: './assessments.component.html',
  styleUrls: ['./assessments.component.scss']
})
export class AssessmentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
      this.initDatatable()
  }

  private initDatatable(): void {
      let tableId: any = $('#table');
      let tableWidget = tableId.DataTable({
          select: true,
          pageLength: 25,
          dom: 'Bfrtip',
      });
      $('.dataTables_length, .dataTables_filter').hide();
      $('.next').css('float', 'right');
  }
}
